import { Sparkles, ArrowRight } from "lucide-react";
import Reveal from "@/components/Reveal";

export default function ConciergeCTA() {
    return (
        <section className="relative overflow-hidden bg-forest-dark py-20 sm:py-24" data-testid="concierge-cta">
            <div className="pointer-events-none absolute -left-32 top-0 h-80 w-80 rounded-full bg-gold/10 blur-3xl" />
            <div className="pointer-events-none absolute -right-32 bottom-0 h-80 w-80 rounded-full bg-wa/10 blur-3xl" />
            <div className="relative mx-auto max-w-3xl px-4 text-center sm:px-6">
                <Reveal>
                    <span className="inline-flex items-center gap-2 rounded-full border border-gold/30 bg-gold/10 px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.2em] text-gold">
                        <Sparkles className="h-3.5 w-3.5" />
                        Concierge Digital
                    </span>
                    <h2 className="mt-5 font-serif text-3xl font-semibold tracking-tight text-white sm:text-4xl lg:text-5xl">
                        Encontre seu resort ideal
                    </h2>
                    <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-stone-300">
                        Conte para nosso consultor virtual como você imagina sua viagem — ele entende seu perfil e
                        recomenda os resorts do portal que mais combinam com você.
                    </p>
                    <button
                        type="button"
                        data-testid="concierge-cta-start"
                        onClick={() => window.dispatchEvent(new Event("open-agent"))}
                        className="group mt-8 inline-flex items-center gap-2 rounded-full bg-sun px-8 py-4 text-sm font-semibold text-forest-deep shadow-xl shadow-amber-900/30 transition-all duration-200 hover:-translate-y-px hover:bg-gold hover:text-white active:scale-[0.98]"
                    >
                        Começar
                        <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                    </button>
                    <p className="mt-4 text-xs text-stone-400">Conversa de 1 minuto · sem cadastro · atendimento humano no WhatsApp quando você quiser</p>
                </Reveal>
            </div>
        </section>
    );
}
